import { motion } from "framer-motion";
import { SOCIALS } from "../constants/contact";

/* Glifos de marca como SVG inline (currentColor) */
const IgIcon = (p) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...p}>
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z" />
  </svg>
);
const FbIcon = (p) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...p}>
    <path d="M9.101 23.691v-7.98H6.627v-3.667h2.474v-1.58c0-4.085 1.848-5.978 5.858-5.978.401 0 .955.042 1.468.103a8.68 8.68 0 0 1 1.141.195v3.325a8.623 8.623 0 0 0-.653-.036 26.805 26.805 0 0 0-.733-.009c-.707 0-1.259.096-1.675.309a1.686 1.686 0 0 0-.679.622c-.258.42-.374.995-.374 1.752v1.297h3.919l-.386 2.103-.287 1.564h-3.246v8.245C19.396 23.238 24 18.179 24 12.044c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.628 3.874 10.35 9.101 11.647z" />
  </svg>
);
const TtIcon = (p) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...p}>
    <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" />
  </svg>
);

// Las tres redes giran en una órbita común alrededor de un núcleo dorado.
// Cada icono gira al revés que la órbita para quedarse siempre derecho.
const NODES = [
  { key: "instagram", href: SOCIALS.instagram, label: "Instagram", Icon: IgIcon, color: "#E1306C" },
  { key: "facebook", href: SOCIALS.facebook, label: "Facebook", Icon: FbIcon, color: "#1877F2" },
  { key: "tiktok", href: SOCIALS.tiktok, label: "TikTok", Icon: TtIcon, color: "#25F4EE" },
];

const W = 400;          // lienzo
const R = 132;          // radio de la órbita
const VUELTA = 54;      // segundos por vuelta completa

const Node = ({ n, i }) => {
  const ang = (i / NODES.length) * 2 * Math.PI - Math.PI / 2; // arranca arriba
  const x = W / 2 + R * Math.cos(ang);
  const y = W / 2 + R * Math.sin(ang);
  return (
    <motion.a
      href={n.href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={`menu-social-${n.key}`}
      aria-label={n.label}
      className="group absolute pointer-events-auto"
      style={{ left: x - 36, top: y - 36, width: 72, height: 72, "--brand": n.color }}
      initial={{ opacity: 0, scale: 0.2 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 0.35 + i * 0.12, duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
    >
      {/* contragiro: mantiene el icono derecho mientras la órbita rota */}
      <motion.span
        className="absolute inset-0 block"
        animate={{ rotate: -360 }}
        transition={{ duration: VUELTA, repeat: Infinity, ease: "linear" }}
        style={{ transformOrigin: "50% 50%" }}
      >
        <motion.span className="absolute inset-0 block" whileHover={{ scale: 1.14 }} transition={{ duration: 0.4 }}>
          <svg className="absolute inset-0 w-full h-full text-[#C5A059]/50 group-hover:text-[var(--brand)] transition-colors duration-500" viewBox="0 0 72 72" fill="none">
            <motion.circle
              cx="36" cy="36" r="34" stroke="currentColor" strokeWidth="1" strokeDasharray="5 9" strokeLinecap="round"
              animate={{ rotate: 360 }} transition={{ duration: 13, repeat: Infinity, ease: "linear" }} style={{ transformOrigin: "36px 36px" }}
            />
          </svg>
          <span className="absolute inset-[7px] rounded-full border border-[#C5A059]/40 bg-[#0a0a0a] flex items-center justify-center text-[#C5A059] shadow-[0_6px_28px_rgba(197,160,89,0.18)] transition-all duration-500 group-hover:border-[var(--brand)] group-hover:text-[var(--brand)] group-hover:shadow-[0_0_38px_var(--brand)]">
            <n.Icon width={23} height={23} />
          </span>
          <span className="pointer-events-none absolute left-1/2 -translate-x-1/2 top-[78px] whitespace-nowrap text-[0.55rem] uppercase tracking-[0.3em] text-zinc-500 opacity-0 transition-all duration-500 group-hover:opacity-100 group-hover:text-[var(--brand)]">
            {n.label}
          </span>
        </motion.span>
      </motion.span>
    </motion.a>
  );
};

export const MenuSocials = () => {
  const C = W / 2;
  return (
    <div className="pointer-events-none absolute inset-y-0 right-[4%] hidden md:flex items-center justify-center" data-testid="menu-socials">
      <div className="relative" style={{ width: W, height: W }}>
        {/* atmósfera: anillos a distintas velocidades y sentidos */}
        <svg className="absolute inset-0 w-full h-full overflow-visible" viewBox={`0 0 ${W} ${W}`} fill="none" aria-hidden="true">
          <defs>
            <radialGradient id="nucleo">
              <stop offset="0%" stopColor="#C5A059" stopOpacity="0.5" />
              <stop offset="60%" stopColor="#C5A059" stopOpacity="0.08" />
              <stop offset="100%" stopColor="#C5A059" stopOpacity="0" />
            </radialGradient>
          </defs>

          <circle cx={C} cy={C} r="78" fill="url(#nucleo)" />

          <motion.g animate={{ rotate: 360 }} transition={{ duration: 90, repeat: Infinity, ease: "linear" }} style={{ transformOrigin: `${C}px ${C}px` }}>
            <circle cx={C} cy={C} r="186" stroke="#C5A059" strokeOpacity="0.09" strokeWidth="1" strokeDasharray="2 14" />
          </motion.g>
          <motion.g animate={{ rotate: -360 }} transition={{ duration: 64, repeat: Infinity, ease: "linear" }} style={{ transformOrigin: `${C}px ${C}px` }}>
            <circle cx={C} cy={C} r="162" stroke="#C5A059" strokeOpacity="0.13" strokeWidth="1" strokeDasharray="22 16" strokeLinecap="round" />
          </motion.g>
          {/* carril por el que viajan los iconos */}
          <circle cx={C} cy={C} r={R} stroke="#C5A059" strokeOpacity="0.16" strokeWidth="1" />
          <motion.g animate={{ rotate: 360 }} transition={{ duration: 34, repeat: Infinity, ease: "linear" }} style={{ transformOrigin: `${C}px ${C}px` }}>
            <circle cx={C} cy={C} r="92" stroke="#C5A059" strokeOpacity="0.1" strokeWidth="1" strokeDasharray="3 11" />
          </motion.g>

          {/* núcleo */}
          <circle cx={C} cy={C} r="4" fill="#C5A059" />
          <motion.circle
            cx={C} cy={C} r="4" fill="none" stroke="#C5A059" strokeWidth="1"
            animate={{ r: [4, 26], opacity: [0.65, 0] }}
            transition={{ duration: 3.4, repeat: Infinity, ease: "easeOut" }}
          />
        </svg>

        {/* la órbita entera gira; dentro, cada icono contragira */}
        <motion.div
          className="absolute inset-0"
          animate={{ rotate: 360 }}
          transition={{ duration: VUELTA, repeat: Infinity, ease: "linear" }}
          style={{ transformOrigin: "50% 50%" }}
        >
          {NODES.map((n, i) => (
            <Node key={n.key} n={n} i={i} />
          ))}
        </motion.div>
      </div>
    </div>
  );
};

/* Fila compacta para móvil (el lienzo grande se oculta en pantallas chicas) */
export const MenuSocialsMobile = () => (
  <div className="flex md:hidden items-center gap-5 pt-2" data-testid="menu-socials-mobile">
    {NODES.map((n) => (
      <a
        key={n.key}
        href={n.href}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={n.label}
        data-testid={`menu-social-m-${n.key}`}
        className="w-10 h-10 rounded-full border border-[#C5A059]/40 bg-[#0a0a0a] flex items-center justify-center text-[#C5A059] transition-colors duration-300"
        style={{ "--brand": n.color }}
      >
        <n.Icon width={17} height={17} />
      </a>
    ))}
  </div>
);
